<template>
  <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

* {
  -webkit-box-sizing: border-box;
     -moz-box-sizing: border-box;
          box-sizing: border-box;
}
*:before,
*:after {
  -webkit-box-sizing: border-box;
     -moz-box-sizing: border-box;
          box-sizing: border-box;
}
body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, legend, input, button, textarea, p, blockquote, th, td {
    margin: 0;
    padding: 0;
}
body {
    background: #fff;
    color: #555;
    font-size: 14px;
    font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
}
td, th, caption {
    font-size: 14px;
}
h1, h2, h3, h4, h5, h6 {
    font-weight: normal;
    font-size: 100%;
}
address, caption, cite, code, dfn, em, strong, th, var {
    font-style: normal;
    font-weight: normal;
}
a {
    color: #555;
    text-decoration: none;
}
a:hover {
    text-decoration: underline;
}
img {
    border: none;
    vertical-align: middle;
}
ol, ul, li {
    list-style: none;
}
input, textarea, select, button {
    font: 14px "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
}
table {
    border-collapse: collapse;
}
html, body {
    height: 100%;
    overflow: hidden;
}
.clearfix:before,
.clearfix:after {
    content: " ";
    display: inline-block;
    height: 0;
    clear: both;
    visibility: hidden;
}
.clearfix {
    *zoom: 1;
}
 
/*公共类*/
.fl {
    float: left
}
.fr {
    float: right
}
.al {
    text-align: left
}
.ac {
    text-align: center
}
.ar {
    text-align: right
}
.hide {
    display: none
}

/* 移动端全局适配 */
@media screen and (max-width: 768px) {
  /* Element Plus Dialog 适配 */
  .el-dialog {
    width: 90% !important;
    max-width: 95% !important;
    margin-top: 10vh !important;
  }
  
  /* Message Box 适配 */
  .el-message-box {
    width: 90% !important;
    max-width: 95% !important;
  }
  
  /* Drawer 适配 */
  .el-drawer {
    width: 80% !important;
  }
  
  /* 表格适配：允许横向滚动 */
  .el-table {
    overflow-x: auto;
  }
  
  /* 表单适配：label 顶部对齐 */
  .el-form-item {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .el-form-item__label {
    text-align: left;
    width: 100% !important;
    justify-content: flex-start;
    margin-bottom: 5px;
  }
  
  .el-form-item__content {
    width: 100%;
    margin-left: 0 !important;
  }
  
  /* 输入框宽度适配 */
  .el-input, .el-select, .el-date-editor, .el-cascader {
    width: 100% !important;
  }

  /* 分页适配 */
  .el-pagination {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .el-pagination .el-pagination__total,
  .el-pagination .el-pagination__sizes {
    display: none !important; /* 移动端隐藏总数和页码选择，节省空间 */
  }

  /* 卡片容器适配 */
  .el-card__body {
    padding: 10px !important;
  }

  /* 搜索区域适配 */
  .filter-card .el-form-item {
    margin-bottom: 10px;
    margin-right: 0;
  }
  
  /* 调整一些常用的间距 */
  .el-main {
    padding: 10px !important;
  }
  
  /* 列布局适配 */
  .el-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    margin-bottom: 10px;
  }
}
</style>
